import type { AppEnvironment } from './types';
import { ESTATE_PAGE_COPY } from './page-copy-estate';

/**
 * SBM / Ontec local validation against localhost Docker stack.
 * Run: npm run dev:sbm (port 4303)
 *
 * Login: resident@sbm.local / ResidentDev123!
 * Uses Tenant API direct auth — not Core portal-auth.
 */
export const env: AppEnvironment = {
  production: false,
  buildMode: 'sbm-local',
  apiBaseUrl: 'http://localhost:3002/v1',
  coreApiUrl: 'http://localhost:3000/v1',
  appTemplateId: '',
  authMode: 'tenant',
  localDevDirectTenant: true,
  localDevTenantId: '9f6ba3bb-dfa1-4bd4-8d36-80bb5bd153bc',
  portalOwnerType: 'member',
  loadDomainConfig: true,
  defaultDomain: 'sbm.local.dev',
  rootTenantId: '',
  portalBaseUrl: 'http://localhost:4303',
  appName: 'Community',
  version: '1.0.0',
  appShell: 'classic',
  appRatingEnabled: false,
  welcomeContent: {
    eyebrow: 'Community companion',
    title: 'The estate,\nin your pocket.',
    subtitle: 'Access and estate services in one place.',
  },
  communitySelectContent: {
    title: 'Choose your community',
    subtitle: 'Search for your estate or complex to continue.',
  },
  signupTermsUrl: 'https://www.ip4estates.com/terms',
  pageCopy: ESTATE_PAGE_COPY,
  home: {
    widgetMode: true,
    widgets: [
      { id: 'account', type: 'account', title: 'Account', order: 1, enabled: true, requiresModule: 'financials' },
      { id: 'support', type: 'support', title: 'Helpdesk', order: 2, enabled: true, requiresModule: 'support' },
      { id: 'events', type: 'events', title: 'Upcoming events', order: 3, enabled: true, requiresModule: 'events' },
      { id: 'panic', type: 'panic', title: 'Emergency', order: 4, enabled: true, requiresModule: 'panic' },
      { id: 'utilities', type: 'utilities', title: 'Utilities', order: 5, enabled: true, requiresModule: 'utilities' },
      { id: 'access', type: 'access', title: 'Visitor access', order: 6, enabled: true, requiresModule: 'access_management' },
    ],
  },
};
